import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs'
import VueElementLoading from 'vue-element-loading';
import Pagination from './../../shared/pagination'

import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
import csvHelper from '../importjsontocsv';
import Loader from './../../shared/loader'

import {
	Validator
} from 'vee-validate'

export default {
	name: 'transactionlogreport',
	components: {
		Pagination,
		DatePicker,
		download,
		VueElementLoading,
		Loader,
		JsonExcel,
		BasicSelect
	},

	data: function () {
		return {
			currentPage: 1,
			totalPage: 0,
			totalrows: 0,
			pageLimit: 10,
			isSelected: false,
			payloadData: '',
			responseData: '',
			isLoading: false,
			userid: '',
			errortype: '',
			listWarehouseData: [],
			listClientData: [],
			listTransactionLogData: [],
			listErrorTypeNames: [],
			formattedDate: '',
			clientid: '',
			client: '',
			ClientErr: '',
			clientSelected: '',
			toDateFlt: '',
			fromDateFlt: '',
			show: false,
			download: true,
			exceedFlag: false,
			limitExeed: false,
			pageno: '',
			csvFields: [],
			csvFieldsForXls: {},
			csvCheck: '',
			listTransactionLogReportDataforxls: [],
			reportname: '',
			resultCount: '',
			isLoadingforxls: false,
			clientname: '',
			warehousename: '',
			status: '',
			processname: '',
			editApi: false,
			apiid: '',
			eheader: '',
			epayload: '',
			apitype: '',
			requestid: '',
			apiTypeError: '',
			query: '',
			example1: `{ "pono": "PO04104002" }`,
			example2: `{"details":[{ "sku": "4897116387160" }]}`
		}
	},

	created: function () { },

	filters: {
		capitalize: function (value) {
			if (!value) return ''
			value = value.toString()
			return value.charAt(0).toUpperCase() + value.slice(1)
		}
	},

	mounted() {
		this.calldateFunction()
		this.formattedDate = moment(new Date()).format('DD/MM/YYYY HH:mm:ss');
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = this.userid = userdetail.userid;
		var loginuserid = userdetail.userid;
		this.userid = userdetail.userid;
		this.createdbyEmail = userdetail.email;
		this.reportname = this.$t('editedjson.transactionlogreport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				//	this.gettransactionlist();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				// this.getWarehouseList();
				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},

	methods: {
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.toDateFlt = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 7);
			this.fromDateFlt = dt;
		},

		onPageChange(page) {
			this.currentPage = page;
			this.gettransactionlist()
			//this.getErrorLogReportData()
		},
		copymodalopen(payload, response) {
			this.payloadData = payload;
			this.responseData = response;
			this.isSelected = true;
		},

		copy(msg) {
			let data = this.payloadData;
			if(msg === 'Response'){
				data = this.responseData;
			}
			navigator.clipboard.writeText(JSON.stringify(data, null, 4));
			this.$alertify.success(`${msg} Copied`)
		},
		retryapi(data) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;

			if(data.processname === 'inbound_po_internal'){
				data.headers.isPOMasterFailed = data.response.isfailed ? data.response.isPOMasterFailed : (data.response.data ?  data.response.data.isPOMasterFailed : true);
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'transactionlog/retryapi',
				'data': {
					id: data.id,
					clientid: this.client,
					apitype: this.apitype,
					traceid: data.traceid,
					methodname: data.methodname,
					apiurl: data.url,
					headers: data.headers,
					payload: data.payload
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (result.data.ErrorCode == 0) {
						this.$alertify.success(result.data.msg)
					} else {
						this.$alertify.error(result.data.msg)
					}
					this.gettransactionlist()
				}, error => {
					console.error(error);
				});
		},
		closecopymodal() {
			this.payloadData = '';
			this.responseData = '';
			this.isSelected = false;
			this.editApi = false;

		},
		editmodalopen(data) {
			let payload = data.payload
			this.epayload = JSON.stringify(data.payload, null, 4);
			this.eheader = JSON.stringify(data.headers, null, 4);
			this.apiid = data.id;
			this.editApi = true;

		},
		updateapi(apiid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: "POST",
				url: apiUrl.api_url + "transactionlog/updateretryapi",
				data: {
					clientid: this.client,
					apiid: apiid,
					apitype: this.apitype,
					payloads: this.epayload,
					headers1: this.eheader
				},
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(response => {
					this.isLoading = true;
					if (response.data.ErrorCode == 0) {
						this.isLoading = false;
						this.$alertify.success(response.data.msg);
						this.editApi = false;
						this.gettransactionlist()
					} else if (response.data.ErrorCode == -1) {
						this.isLoading = false;
						this.$alertify.error(response.data.msg);
						this.editApi = false;
						this.gettransactionlist()
					}

				})
				.catch(httpException => {
					console.error("exception is:::::::::", httpException);
				});
		},
		dateFormat(date) {
			if (!date) {
				return '';
			} else {
				return moment(date).format('DD-MM-YY HH:mm:ss');
			}
		},
		resetForm() {
			this.listTransactionLogData = [];
			// this.client = '';
			// this.clientid = '';
			this.apitype='';
			this.fromDateFlt = '';
			this.toDateFlt = '';
			this.errortype = '';
			this.totalrows = 0;
			this.status = '';
			this.processname = '';
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		gettransactionlist(obj) {
			//alert('sdsk'+this.client)
			if (obj) {
				this.currentPage = 1;
			}
			if (this.clientid == '' && this.client == '') {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listTransactionLogData = [];
				return false;
			}
			if (!this.apitype) {
				this.apiTypeError = this.$t('reports.apitypeError');
				this.pageNo = this.totalPage = 0;
				this.listTransactionLogData = [];
				return false;
			}
			var clientListEncrypt = window.localStorage.getItem('clientList');
			var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
			var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
			this.listClientData = JSON.parse(plaintextclient);

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'transactionlog/getretryapis',
				'data': {
					clientid: window.localStorage.getItem('selectedClient'),
					errortype: this.errortype,
					processname: this.processname,
					status: this.status,
					apitype: this.apitype,
					traceid: this.requestid,
					query: this.query,
					fromupdatedat: this.dateFormat1(this.fromDateFlt),
					toupdatedat: this.dateFormat2(this.toDateFlt),
					limit: this.pageLimit,
					offset: (this.currentPage - 1) * this.pageLimit
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.listTransactionLogData = result.data.result;
					this.totalrows = Number(result.data.totalRows);

					if (this.totalrows < this.pageLimit) {
						this.totalPage = 1
					} else {
						this.totalPage = Math.ceil(this.totalrows / this.pageLimit);
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				});
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);

		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		getTransactionLogReportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getTransactionLogReportData(2);
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			//alert('hii')
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getTransactionLogReportxslData(3)
			}

		},
		getTransactionLogReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			this.exceedFlag = false;

			this.searchFlag = true;
			this.isLoading = true;


			var errortype = '';
			if (this.errortype != '' || this.errortype != null) {
				errortype = this.errortype
			}
			var clientdata = '';

			if (this.user_type == 'warehouse_user') {
				if (!this.client) {
					for (var i = 1; i < this.listClientData.length; i++) {
						if (i == this.listClientData.length - 1) {
							clientdata += this.listClientData[i].clientid;
						} else {
							clientdata += this.listClientData[i].clientid + ',';
						}
					}
				}
			}


			this.input = ({
				clientid: this.client,
				errortype: this.errortype,
				processname: this.processname,
				apitype: this.apitype,
				traceid: this.requestid,
				query: this.query,
				status: this.status,
				fromupdatedat: this.dateFormat1(this.fromDateFlt),
				toupdatedat: this.dateFormat2(this.toDateFlt),
				limit: 100,
				offset: 0
			})

			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'transactionlog/getretryapis',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						this.listTransactionLogReportDataCsv = [];
						this.show = true;
						this.download = false;						
						this.csvFields = {
							'processname': this.$t('reports.processName'),
							'errortype': this.$t('errorLogReport.errorType'),
							'createdat':  this.$t('errorLogReport.date'),
							'url':  this.$t('errorLogReport.apiName'),
							'status': this.$t('warehouseRacks.status'),
							'updatedat': this.$t('reports.updatedDate'),
							'failedcount':  this.$t('reports.failedCount'),
							'errordescription': this.$t('common.description'),
							'traceid' : this.$t('editedjson.traceid'),
							'payload' : 'payload',
							'response' : 'response'
						};
						var dateFilder = [];
						var skipFilter = ['id', 'internal', 'methodname', 'headers' ,'response' , 'payload'];
						this.listTransactionLogReportDataCsv = result.data.result;
						this.listTransactionLogReportDataCsv.forEach(function (entry) {

							if (entry.createddate != '' && entry.createddate != null) {
								entry.createddate = moment(entry.createddate).format('YYYY-MM-DD HH:mm:ss');
							}
						});
						csvHelper.data.jsonToCSV(this.$t('editedjson.transactionlogreport'), this.listTransactionLogReportDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);

					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getTransactionLogReportxslData(csvCheck = 3) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.searchFlag = true;
			var clientListEncrypt = window.localStorage.getItem('clientList');
			var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
			var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
			this.listClientData = JSON.parse(plaintextclient);

			this.show = true;
			this.download = false;

			this.dataFilter2 = [];
			var value = '';
			var str = '';
			var clientdata = '';

			var errortype = '';
			if (this.errortype != '' || this.errortype != null) {
				errortype = this.errortype
			}

			if (this.user_type == 'warehouse_user') {
				if (!this.client) {
					for (var i = 1; i < this.listClientData.length; i++) {
						if (i == this.listClientData.length - 1) {
							clientdata += this.listClientData[i].clientid;
						} else {
							clientdata += this.listClientData[i].clientid + ',';
						}
					}
				}
			}

			if (csvCheck == 2)
				this.pageno = 0;

			this.input = ({
				clientid: this.client,
				errortype: this.errortype,
				processname: this.processname,
				apitype: this.apitype,
				traceid: this.requestid,
				query: this.query,
				status: this.status,
				fromupdatedat: this.dateFormat1(this.fromDateFlt),
				toupdatedat: this.dateFormat2(this.toDateFlt),
				limit: 100,
				offset: 0
			})

			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['clientdata', 'offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'transactionlog/getretryapis',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						this.listTransactionLogReportDataforxls = [];

						this.csvFieldsForXls =[];
						this.csvFieldsForXls[this.$t('reports.processName')] ='processname',
						this.csvFieldsForXls[this.$t('errorLogReport.errorType')] = 'errortype',
						this.csvFieldsForXls[this.$t('errorLogReport.date')] = 'createdat',
						this.csvFieldsForXls[this.$t('errorLogReport.apiName')] = 'url',
						this.csvFieldsForXls[this.$t('warehouseRacks.status')] = 'status',
						this.csvFieldsForXls[ this.$t('reports.updatedDate')] =  'updatedat',
						this.csvFieldsForXls[ this.$t('reports.failedCount')] = 'failedcount',
						this.csvFieldsForXls[ this.$t('common.description')] = 'errordescription',
							//'Payload':'payload'
						
						this.listTransactionLogReportDataforxls = result.data.result;

						this.listTransactionLogReportDataforxls.forEach(function (entry) {
							if (entry.createddate != '' && entry.createddate != null) {
								entry.createddate = moment(entry.createddate).format('YYYY-MM-DD HH:mm:ss');

							}
						});

					}
				}, error => {
					console.error(error);
				})
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/transactionlogreport/transactionlogreport.component.js